import React, {useState} from "react";
import ReactDOM from "react-dom";
import MUIDataTable from "../../src/";
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import {makeStyles} from "@material-ui/core/styles";

import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  data: {
    display: 'inline-block',
  },
  sortAction: {
    display: 'flex',
    verticalAlign: 'top',
    cursor: 'pointer',
  },
  sortLabelRoot: {
    height: '10px',
  },
  sortActive: {
    color: theme.palette.text.primary,
  },
  toolButton: {
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  hintIconAlone: {
    marginTop: '-3px',
    marginLeft: '3px',
  },
  hintIconWithSortIcon: {
    marginTop: '-3px',
  },
}));

function Example(props) {

  const classes = useStyles();
  const handleKeyboardSortinput = (e, updateDirection, idx) => {
    if (e.key === 'Enter') {
      updateDirection(idx);
    }

    return false;
  };

  const [sortOrder, setSortOrder] = useState({
    columnName: 'Title',
    sortDirection: 'asc',
  });

  const removeOrder = () => {
    setSortOrder({});
  };

  const columns = [
    {
      name: "Name",
      options: {
        filter: true,
        display: 'excluded',
      }
    },      
    {
      label: "Modified Title Label",
      name: "Title",
      options: {
        filter: true,
        sortDirection: 'asc',
        customHeadLabelRender: (columnMeta) => {
          return columnMeta.label + '!!';
        }
      }
    },
    {
      name: "Location",
      options: {
        filter: false,
        customHeadRender: (columnMeta, sortOrder, updateDirection) => {
          
          var sortDirProps = {
            height:'10px',
            classes: { root: classes.sortLabelRoot },
          };
          if (columnMeta.name === sortOrder.columnName && ['asc','desc'].indexOf(sortOrder.sortDirection) !== -1) {
            sortDirProps.direction = sortOrder.sortDirection;
            sortDirProps.active = true;
          } else {
            sortDirProps.active = false;
          }

          return (
            <TableCell key={2} scope={'col'} sortDirection={sortDirProps.direction ? sortDirProps.direction : false}>
              <Tooltip title="Sort This Thing!" placement={'bottom-start'}>
                <span 
                  role="button" 
                  tabIndex={0}
                  onKeyUp={(event) => this.handleKeyboardSortinput(event, updateDirection, 2) }
                  onClick={() => updateDirection(2)} 
                  style={{ cursor: 'pointer',display:'flex', outline:'none' }}>
                  <div style={{color:'blue', display:'inline-block'}}>
                    {columnMeta.name}
                  </div>
                  <div style={{display: 'flex',verticalAlign: 'top',cursor: 'pointer'}}>
                    <TableSortLabel {...sortDirProps} />
                  </div>
                </span>
              </Tooltip>
            </TableCell>
          );
        }
      }
    },
    {
      name: "Age",
      options: {
        filter: true,
      }
    },
    {
      name: "Salary",
      options: {
        filter: true,
        sort: false
      }
    }      
  ];


  const data = [
    ["Gabby George", "Business Analyst", "Minneapolis", 30, "$100,000"],
    ["Aiden Lloyd", "Business Consultant", "Dallas",  55, "$200,000"],
    ["Jaden Collins", "Attorney", "Santa Ana", 27, "$500,000"],
    ["Franky Rees", "Business Analyst", "St. Petersburg", 22, "$50,000"],
    ["Aaren Rose", "Business Consultant", "Toledo", 28, "$75,000"],
    ["Blake Duncan", "Business Management Analyst", "San Diego", 65, "$94,000"],
    ["Frankie Parry", "Agency Legal Counsel", "Jacksonville", 71, "$210,000"],
    ["Lane Wilson", "Commercial Specialist", "Omaha", 19, "$65,000"],
    ["Robin Duncan", "Business Analyst", "Los Angeles", 20, "$77,000"],
    ["Mel Brooks", "Business Consultant", "Oklahoma City", 37, "$135,000"],
    ["Harper White", "Attorney", "Pittsburgh", 52, "$420,000"],
    ["Kris Humphrey", "Agency Legal Counsel", "Laredo", 30, "$150,000"],
    ["Frankie Long", "Industrial Analyst", "Austin", 31, "$170,000"],
    ["Brynn Robbins", "Business Analyst", "Norfolk", 22, "$90,000"],
    ["Justice Mann", "Business Consultant", "Chicago", 24, "$133,000"],
    ["Addison Navarro", "Business Management Analyst", "New York", 50, "$295,000"],
    ["Jesse Welch", "Agency Legal Counsel", "Seattle", 28, "$200,000"],
    ["Eli Mejia", "Commercial Specialist", "Long Beach", 65, "$400,000"],
    ["Gene Leblanc", "Industrial Analyst", "Hartford", 34, "$110,000"],
    ["Danny Leon", "Computer Scientist", "Newark", 60, "$220,000"],
    ["Lane Lee", "Corporate Counselor", "Cincinnati", 52, "$180,000"],
    ["Jesse Hall", "Business Analyst", "Baltimore", 44, "$99,000"],
    ["Danni Hudson", "Agency Legal Counsel", "Tampa", 37, "$90,000"],
    ["Terry Macdonald", "Commercial Specialist", "Miami", 39, "$140,000"],
    ["Justice Mccarthy", "Attorney", "Tucson", 26, "$330,000"],
    ["Silver Carey", "Computer Scientist", "Memphis", 47, "$250,000" ],
    ["Franky Miles", "Industrial Analyst", "Buffalo", 49, "$190,000"],
    ["Glen Nixon", "Corporate Counselor", "Arlington", 44, "$80,000"],
    ["Gabby Strickland", "Business Process Consultant", "Scottsdale", 26, "$45,000"],
    ["Mason Ray", "Computer Scientist", "San Francisco", 39, "$142,000"]
  ];

  const options = {
    filter: true,
    filterType: 'dropdown',
    displayMode: 'responsiveStacked',
    sortOrder: sortOrder // defined above
  };

  return (
    <>
      <Button onClick={removeOrder}>Remove Sort Order</Button>
      <MUIDataTable title={"ACME Employee list"} data={data} columns={columns} options={options} />
    </>
  );
}

export default Example;
